<template>
   <div class="container">
    <el-page-header class="page-header" @back="goBack" content="配送订单详情"></el-page-header>
    <div class="pay-header">
      <span style="font-size: 30px; color: #156098;">{{orderInfo.statusText}}</span>
      <span style="font-size: 20px; color: #666666;" v-if="orderInfo.status == 0">支付剩余时间：{{countDownHour}}:{{countDownMinute}}:{{countDownSecond}}</span>
      <el-button class="btn-confirm" type="primary" @click="toPayPage" v-if="orderInfo.status == 0">￥{{orderInfo.sumPrice}}支付</el-button>
      <el-button class="btn-confirm" @click="applyRefund" v-if="orderInfo.refundFlag == 'Y'">申请退款</el-button>
    </div>
    <AreaHeader class="area-header-one" title="配送订单信息"></AreaHeader>
    <div class="row-container" style="margin-top: 10px;"  v-if="orderInfo.status >= 4 && (orderInfo.expressName || orderInfo.expressNo)">
       <ul style="margin-top: 10px;display: flex;flex-direction: row;">
         <li v-show="orderInfo.expressName"><b>快递公司：</b>{{orderInfo.expressName}}</li>
         <li style="margin-left: 30px;"  v-show="orderInfo.expressNo"><b>物流订单号：</b>{{orderInfo.expressNo}}</li>
       </ul>
    </div>
    <el-collapse v-model="activeNames" class="collapse" v-if="orderInfo.status >= 4 && expressInfo">
      <el-collapse-item class="collapse-item" name="1">
        <template slot="title">
            <div class="row-container">
              <img src="../../../static/image/ic_delivery.png" style="width: 35px; height: 30px; margin-right: 20px;"/>
              <div style="font-size: 22px;color: #333333;line-height: 22px;text-align: start;" v-if="expressInfo.companyName">{{expressInfo.companyName+': '}}</div>
              <div style="font-size: 22px;color: #333333;line-height: 22px;text-align: start;margin-right: 10px;" v-if="expressInfo.data">{{expressInfo.data[0].context}}</div>
              <div style="font-size: 22px;color: #333333;line-height: 22px;text-align: start;margin-right: 10px;" v-if="expressInfo.data == null">暂无物流信息</div>
              <div style="font-size: 20px; color: #999999;line-height: 18px;text-align: end;" v-if="expressInfo.data">{{expressInfo.data[0].time}}</div>
            </div>
        </template>
        <div v-if="expressInfo.data" class="colomn-container padding" style="margin-top: 30px;" v-for="express in expressInfo.data">
          <span class="transit-text">{{express.context}}</span>
          <span class="transit-time">{{express.time}}</span>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="row-container" style="margin-top: 20px;">
      <ul class="basic-info" v-if="orderInfo">
        <li><b>收件人姓名：</b>{{orderInfo.recipientName}}</li>
        <li><b>收件人联系方式：</b>{{orderInfo.recipientPhone}}</li>
        <li><b>收货地址：</b>{{orderInfo.recipientAddress}}</li>
        <li v-if="orderInfo.zipCode"><b>邮编：</b>{{orderInfo.zipCode}}</li>
      </ul>
      <el-button v-if="orderInfo.status == 0 || (orderInfo.status > 0 && orderInfo.refundFlag == 'Y')" style="margin-left: 100px;" type="text" size="medium" icon="el-icon-edit" @click="modifyAddress">修改</el-button>
    </div>
    <el-divider></el-divider>
    <div class="row-container" style="margin-top: 20px;">
      <ul class="basic-info" v-if="orderInfo">
          <li><b>中草药形态：</b>{{orderInfo.formText}}</li>
          <li><b>几副药：</b>{{orderInfo.formCount}}</li>
          <li><b>下单时间：</b>{{orderInfo.createTime}}</li>
          <li v-if="orderInfo.status >= 1 && orderInfo.payTime"><b>付款时间：</b>{{orderInfo.payTime}}</li>
          <li><b>配送订单编号：</b>{{orderInfo.deliveryOrderId}}</li>
          <li><b>配送中心：</b>{{orderInfo.deliveryName}}</li>
          <li v-if="orderInfo.remark != null && orderInfo.remark.length != 0"><b>备注：</b>{{orderInfo.remark}}</li>
          <li style="font-size: 24px; color: #dd3131;" v-if="orderInfo.status != 0"><b>支付金额：</b>￥{{orderInfo.sumPrice}}</li>
      </ul>
    </div>
    <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
    <div class="row-container" style="margin-top: 20px;">
      <ul class="basic-info" v-if="consultInfo">
          <li><b>姓名：</b>{{consultInfo.name}}</li>
          <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
          <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
          <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
          <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
          <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
          <li v-if="consultInfo.useDate"><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
          <li v-if="consultInfo.useDays"><b>服药天数：</b>{{consultInfo.useDays}}</li>
      </ul>
    </div>
    <AreaHeader class="area-header" title="症状信息"></AreaHeader>
    <table border="1" class="basic-info">
        <tr class="table-rows" v-for="(item,index) in basicTableArray">
            <td v-if="index == 0" :rowspan="basicTableArray.length">基本情况</td>
            <td v-if="item.value.length > 0">{{item.key}}</td>
            <td v-if="item.value.length > 0">{{item.value}}</td>
        </tr>
        <tr class="table-rows" v-for="(item1,index) in shangjiaoTableArray" v-if="hasShangJiao">
            <td v-if="index == 0" :rowspan="shangjiaoTableArray.length">上焦</td>
            <td v-if="item1.value">{{item1.key}}</td>
            <td v-if="item1.value">{{item1.value.toString()}}</td>
        </tr>
        <tr class="table-rows" v-for="(item2,index) in zhongjiaoTableArray" v-if="hasZhongJiao">
            <td v-if="index == 0" :rowspan="zhongjiaoTableArray.length">中焦</td>
            <td v-if="item2.value">{{item2.key}}</td>
            <td v-if="item2.value">{{item2.value.toString()}}</td>
        </tr>
        <tr class="table-rows" v-for="(item3,index) in xiajiaoTableArray" v-if="hasXiaJiao">
            <td v-if="index == 0" :rowspan="xiajiaoTableArray.length">下焦</td>
            <td v-if="item3.value">{{item3.key}}</td>
            <td v-if="item3.value">{{item3.value.toString()}}</td>
        </tr>
    </table>
    <AreaHeader class="area-header-one" title="开方信息"></AreaHeader>
    <h2>{{orderInfo.typeText}}</h2>
    <table border="1" class="drug-table-info">
        <tr class="table-header">
            <td>序号</td>
            <td>药品</td>
            <td>重量（克）</td>
            <td>序号</td>
            <td>药品</td>
            <td>重量（克）</td>
        </tr>
        <tr class="table-rows" v-for="item in tablePrescription.options" :key="item.key">
            <td style="width: 8%;">
              <span class="span-index" v-show="item.key">{{item.index}}</span>
            </td>
            <td style="width: 30%;">
              <div class="item-row" v-show="item.key">
                <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key}}</span>
                <el-button @click="drugChangeClick(item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
              </div>
            </td>
            <td style="width: 12%;">
              <div class="item-row" v-show="item.key">
                <span style="width: 100%; text-align: center;">{{item.value}}g</span>
                <el-button  @click="drugWeightClick(item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
              </div>
            </td>
            <td style="width: 8%;"><span v-show="item.key1" class="span-index">{{item.index1}}</span></td>
            <td style="width: 30%;">
              <div class="item-row" v-show="item.key1">
                <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key1}}</span>
                <el-button @click="drugChangeClick(item,1)" style="width: 25%;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
              </div>
            </td>
            <td style="width: 12%;">
              <div class="item-row" v-show="item.key1">
                <span style="width: 100%; text-align: center;">{{item.value1}}g</span>
                <el-button @click="drugWeightClick(item,1)" style="width: 62px;height:30px; border-color: #156098;color: #156098;display: none;" size="small">更换</el-button>
              </div>
            </td>
        </tr>
        <tr>
            <td class="table-footer-td" colspan="6"><b>*</b>总计：<b>{{tablePrescription.count}}</b>味，<b>{{tablePrescription.totalWeight}}</b>克；<b v-show="tablePrescription.charge != 0" style="color: black;">参考药价：</b><b v-show="tablePrescription.charge != 0">{{tablePrescription.charge}}</b><b v-show="tablePrescription.charge != 0" style="color: black;">元/副</b></td>
        </tr>
        <tr class="table-footer" >
            <td class="table-footer-td" colspan="6"><b>*</b>有效使用期：{{tablePrescription.startDate}} ~ {{tablePrescription.endDate}}</td>
        </tr>
    </table>
  </div>
</template>

<script>
  let un_pay_status  = "0" //未支付
  let payed_status  = "1" //已支付
  let order_avaliable_status  = "2" //订单生效
  let prescripting_status  = "3" //配药中
  let expressing_status  = "4" //配送中
  let express_complete_status  = "5" //配送完成
    import AreaHeader from '@/components/widgets/area-header.vue'
      import { EventBus } from "../../js/eventbus.js"
    export default {
      name:'fulOrder',
      components:{
          AreaHeader,
      },
      data () {
        return {
          orderInfo:{},
          activeNames:'0',
          activeNames1:'1',
          countDownHour:'00',
          countDownMinute:'00',
          countDownSecond:'00',
          tablePrescription:{},
          expressInfo:{},
          basicTableArray:[],
          shangjiaoTableArray:[],
          zhongjiaoTableArray:[],
          xiajiaoTableArray:[],
          consultInfo:{},
          hasShangJiao:false,
          hasZhongJiao:false,
          hasXiaJiao:false,
        }
      },
      mounted() {
        console.log("fulfillmentOrder mounted")
        this.orderId = this.$route.query.orderId
        this.getOrderInfo()
        var address = sessionStorage.getItem('selectAddress')
        // 获取我的地址
        if(address != null && address.length > 0){
          console.log("address:"+address)
          var addressObj = JSON.parse(address)
          sessionStorage.removeItem('selectAddress')
          this.wjtHttp.post(this,'/api/delivery/order/modify/address',{
              deliveryOrderId: this.orderId,
              recipientAddress: addressObj.province+addressObj.city+addressObj.county+addressObj.street,
              recipientName: addressObj.receiverName,
              recipientPhone: addressObj.phoneNo
          },false,(res)=>{
                var data = res.data
                if(data.code == 200){
                  this.$message('地址修改成功')
                  this.getOrderInfo()
                }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'修改地址异常',
                      type:'error'
                  })
                }
            },(err)=>{
                console.log(err)
            })
        }
      },
      methods:{
        goBack(){
            this.$router.go(-1)
        },
        getOrderInfo(){
          this.wjtHttp.get(this,'/api/delivery/order/info/'+this.orderId,{},true,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.orderInfo = data.data
                    if(this.orderInfo.status == un_pay_status){
                      this.startCountDown(data.data.payCountdown)
                    }
                    if(data.data.status >= expressing_status){
                      this.getExpressInfo(this.orderId)
                    }
                    this.consultInfo = data.data.patient
                    this.generateTableData()
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        },
        getExpressInfo(orderId){
          this.wjtHttp.get(this,'/api/delivery/progress/'+orderId,{},false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.expressInfo = data.data
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        },
        startCountDown(timeMill){
          var currentTimeMill = Date.parse(new Date())
          console.log('netMill:'+timeMill)
          console.log('currentMill:'+currentTimeMill)
          if(currentTimeMill > timeMill){
              return
          }
          var totalSecond = (timeMill - currentTimeMill) / 1000;

          clearInterval(this.interval)
          var that = this
          this.interval = setInterval(function () {
            console.log('countdown:'+totalSecond)
            // 秒数
            var second = totalSecond;

            // 小时位
            var hr = Math.floor(second / 3600);
            var hrStr = hr.toString();
            if (hrStr.length == 1) hrStr = '0' + hrStr;

            // 分钟位
            var min = Math.floor((second - hr * 3600) / 60);
            var minStr = min.toString();
            if (minStr.length == 1) minStr = '0' + minStr;

            // 秒位
            var sec = second - hr * 3600 - min * 60;
            var secStr = sec.toString();
            if (secStr.length == 1) secStr = '0' + secStr;
            console.log("hour:"+hrStr)
            console.log("minite:"+minStr)
            console.log("second:"+secStr)
            that.countDownHour=hrStr
            that.countDownMinute=minStr
            that.countDownSecond=secStr
            totalSecond--;
            if (totalSecond < 0) {
              clearInterval(that.interval);
              console.log("倒计时结束")
              that.countDownHour='00'
              that.countDownMinute='00'
              that.countDownSecond='00'
              that.getOrderInfo()
            }
          }, 1000);
        },
        generateTableData(){
          var item = this.orderInfo.prescriptionInfo
          this.tablePrescription.count = item.count
          this.tablePrescription.charge = item.charge
          this.tablePrescription.totalWeight = item.totalWeight
          this.tablePrescription.startDate = item.startDate
          this.tablePrescription.endDate = item.endDate
          this.tablePrescription.title = item.name
          var itemArray = item.prescription
          for (var j = 0; j < itemArray.length;j++){
              var itemJ = itemArray[j]
              if(j%2 == 1){
                  itemArray[j-1].key1 = itemJ.key
                  itemArray[j-1].value1 = itemJ.value
                  itemArray[j-1].index1 = itemJ.index
                  itemArray[j-1].visible1 = false
              }else{
                itemArray[j].visible = false
              }
          }
          var options = []
          for (var k = 0; k < itemArray.length;k++){
              if(k%2 == 0){
                  options.push(itemArray[k])
              }
          }
          this.tablePrescription.options = options

          this.basicTableArray = this.basicTableArray.concat(this.orderInfo.inquiryInfo.basic_array)
          this.basicTableArray = this.basicTableArray.concat(this.orderInfo.inquiryInfo.basic_enter_array)
          this.basicTableArray = this.basicTableArray.concat(this.orderInfo.inquiryInfo.maixiang_array)
          this.shangjiaoTableArray = this.orderInfo.inquiryInfo.shangjiao_array
          this.zhongjiaoTableArray = this.orderInfo.inquiryInfo.zhongjiao_array
          this.xiajiaoTableArray = this.orderInfo.inquiryInfo.xiajiao_array
          var that = this
          this.shangjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasShangJiao = true
              }
          })
          this.zhongjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasZhongJiao = true
              }
          })
          this.xiajiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasXiaJiao = true
              }
          })
        },
        toPayPage(){
          sessionStorage.setItem('fulfillmentPlaceOrderInfo',JSON.stringify(this.orderInfo))
          this.$router.push('/wjtpay')
        },
        modifyAddress(){
          this.$router.push({
            path:'/address',
            query:{
              mode:1
            }
          })
        },
        applyRefund(){
          this.wjtHttp.post(this,'/api/adapay/v1/refund ',{deliveryOrderId: this.orderInfo.deliveryOrderId},false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.$message('操作成功')
                    this.getOrderInfo()
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        }
      },
      destroyed() {
        clearInterval(this.interval)
        EventBus.$off("address",null)
      }
    }
</script>

<style scoped>
  .container{
      width: 1160px;
      margin: auto auto;
      display: flex;
      flex-direction: column;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .btn-confirm{
      width: 200px;
      border-radius: 40px;
      margin-top: 20px;
      font-size: 18px;
      height: 45px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .area-header-one{
    margin-top: 10px;
  }
  .pay-header{
    height: 160px;
    width: 1080px;
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .colomn-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .row-container{
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .transit-text{
      width: auto;
      height: auto;
      padding-right: 20px;
      color: #666666;
      font-size: 20px;
      word-break: break-all;
  }
  .transit-time{
      width: 100%;
      height: auto;
      color: #999999;
      margin-top: 5px;
      font-size: 20px;
      text-align: start;
  }
  .table-header{
      background: #156098;
      height: 70px;
      color: white;
      font-size: 18px;
      font-weight: bold;
  }
  .span-index{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 25px;
    height: 25px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 50%;
    border-style: solid;
    border-color: red;
    border-width: 1px;
  }
  .padding{
      padding-top: 10rpx;
      padding-bottom: 10px;
  }
  .collapse-item{
      margin-top: 30px;
  }
  .collapse{
      width: 1050px;
      margin-left: 24px;
  }
  .basic-info{
      width: 985px;
      margin-top: 30px;
      margin-bottom: 15px;
  }
  .drug-table-info{
      width: 985px;
      margin-top: 10px;
      margin-bottom: 15px;
  }
  .express-info{
      width: 985px;
      margin-top: 10px;
      margin-bottom: 5px;
  }
  .basic-info>li{
      color: #333333;
      font-size: 20px;
      text-align: left;
      min-height: 40px;
      width: 100%;
  }
  .basic-info>li>b{
      font-weight: bold;
  }
  .basic-table{
      margin-left: 35px;
  }
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
  .table-footer-td{
      height: 70px;
      background: white;
      font-size: 18px;
      background: #f9f9f9;
      text-align: left;
      padding-left: 30px;
  }
  .table-footer-td>b{
      font-size: 18px;
      color: red;
  }
  .form-item{
      width: 48%;
  }
  .tabs{
      width: 100%;
      height: auto;
      margin-top: 20px;
      overflow-y: auto;
  }
  .collapse-item{
      margin-top: 30px;
  }
  .collapse{
      width: 1050px;
      margin-left: 24px;
  }
  .dialog-footer{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .radio{
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 0px !important;
    height: 50px !important;
    padding-top: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/fulfillment/fulfillmentOrder.vue